var common = require("../../utiles/common.js")

module.exports = {
    register: function () {
        document.createElement('sso-login')
        ko.components.register('sso-login', {
            viewModel: function (params) {
                var $this = this;
                var service = common.urlSearch(location.href)["service"];
                var searchUrl = window.location.href.split("?")[1];
                var accountName = common.urlSearch(location.href)["accountName"];
                if(searchUrl){
                    if(service && !accountName) {
                        common.redirectTo("/auth/sso/ssoLogin?"+searchUrl);
                    }
                    if(service && accountName) {
                        common.redirectTo("/auth/sso/login/"+service+"?"+searchUrl);
                    }
                    
                }
            },
            template: require("./template/SSOLogin.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/sso/SSOLogin.js
// module id = 149
// module chunks = 0